module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Life I Won")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-fourth-of-march-2009-crash"
    }
  }, [_vm._v("Chapter 1:  Fourth of March 2009 – Crash")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-march-love"
    }
  }, [_vm._v("Chapter 2:  March – Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-march-realisation"
    }
  }, [_vm._v("Chapter 3:  March – Realisation")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-4-march-thought"
    }
  }, [_vm._v("Chapter 4:  March – Thought")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-5-april-home"
    }
  }, [_vm._v("Chapter 5:  April – Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-6-april-revelations"
    }
  }, [_vm._v("Chapter 6:  April – Revelations")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-7-may-spectrum"
    }
  }, [_vm._v("Chapter 7:  May – Spectrum")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#chapter-8-june-turmoil"
    }
  }, [_vm._v("Chapter 8:  June – Turmoil")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#chapter-9-june-debt"
    }
  }, [_vm._v("Chapter 9:  June – Debt")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#chapter-10-june-surprise"
    }
  }, [_vm._v("Chapter 10:  June – Surprise")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#chapter-11-june-ultimatum"
    }
  }, [_vm._v("Chapter 11:  June – Ultimatum")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-june-plan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12:  June – Plan")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-july-cancer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13:  July – Cancer")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-july-visiting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14:  July – Visiting")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-july-stock-take",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15:  July – Stock Take")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-july-visit-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16:  July – Visit Two")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-july-practicalities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17:  July – Practicalities")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-july-mountains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18:  July – Mountains")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-july-plans",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19:  July – Plans")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-july-d-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20:  July – D-Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-august-cavalry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21:  August – Cavalry")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-august-agreement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22:  August – Agreement")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-23-august-fan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23:  August – Fan")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-24-august-shock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24:  August – Shock")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-25-august-confession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25:  August – Confession")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-26-august-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26:  August – Family")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-27-august-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27:  August – Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-28-august-nathan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28:  August – Nathan")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-29-august-bacon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29:  August – Bacon")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-30-august-auntie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30:  August – Auntie")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-31-august-positivity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31:  August – Positivity")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-32-august-honesty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32:  August – Honesty")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-33-august-final",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33:  August – Final")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-34-first-of-september-2009-goodbye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34:  First of September 2009 – Goodbye")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-35-september-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35:  September – Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-36-september-calm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36:  September – Calm")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-37-october-angel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37:  October – Angel")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-38-october-shame",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38:  October – Shame")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-39-october-john",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39:  October – John")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-40-october-halloween",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40:  October – Halloween")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-41-october-charity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41:  October – Charity")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#chapter-42-october-brambles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42:  October – Brambles")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#chapter-43-october-dan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43:  October – Dan")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#chapter-44-october-exit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44:  October – Exit")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#chapter-45-october-ni",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45:  October – Ni")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#chapter-46-november-lou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46:  November – Lou")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#chapter-47-november-progress",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47:  November – Progress")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#chapter-48-november-pennies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48:  November – Pennies")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#chapter-49-november-network",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49 November – Network")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#chapter-50-november-friendships",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50:  November – Friendships")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#chapter-51-november-expectations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51:  November – Expectations")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#chapter-52-december-snow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52:  December – Snow")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#chapter-53-december-baileys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53 December – Baileys")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#chapter-54-december-boom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54:  December – Boom")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#chapter-55-december-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55:  December – Christmas")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#chapter-56-january-mending",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56:  January – Mending")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#chapter-57-january-the-search",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57:  January – The Search")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#chapter-58-january-kindness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58:  January – Kindness")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#chapter-59-january-worthless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59:  January – Worthless")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#chapter-60-january-becca",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60:  January – Becca")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#chapter-61-january-moving",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61:  January – Moving")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#chapter-62-february-settling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62:  February – Settling")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#chapter-63-february-forgiveness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63:  February – Forgiveness")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#chapter-64-february-mindset",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64:  February – Mindset")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#chapter-65-february-skills",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65:  February – Skills")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#chapter-66-march-coastline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 66:  March – Coastline")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#chapter-67-fourth-of-march-2010-possibilities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 67:  Fourth of March 2010 – Possibilities")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0